import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedMaterialModule } from 'src/app/shared-material/shared-material.module';
import { LayoutModule } from '../../layout/layout.module';
import { CompaniaRoutingModule } from './compania-routing.module';
import { FaqPagosComponent } from './faq-pagos/faq-pagos.component';
import { MensajerosRegistroComponent } from './mensajeros/mensajeros-registro/mensajeros-registro.component';
import { PoliticaDatosComponent } from './politica-datos/politica-datos.component';
import { SidebarComponent } from './terminos-condiciones/sidebar/sidebar.component';
import { TerminosCondicionesComponent } from './terminos-condiciones/terminos-condiciones.component';
import { Version10Component } from './terminos-condiciones/version10/version10.component';
import { TiendasMovilComponent } from './tiendas-movil/tiendas-movil.component';
import { RegistroExitosoComponent } from './tiendas/registro/registro-exitoso/registro-exitoso.component';
import { RegistroComponent } from './tiendas/registro/registro.component';


@NgModule({
  declarations: [
    MensajerosRegistroComponent,
    TerminosCondicionesComponent,
    RegistroComponent,
    PoliticaDatosComponent,
    RegistroExitosoComponent,
    FaqPagosComponent,
    TiendasMovilComponent,
    SidebarComponent,
    Version10Component,
  ],
  imports: [
    CommonModule,
    CompaniaRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedMaterialModule,
    LayoutModule,
    NgxSpinnerModule,
    ImageCropperModule,
    MatIconModule,
    MatTooltipModule,
    MatDialogModule
  ],
  exports: [TerminosCondicionesComponent, RegistroComponent, MensajerosRegistroComponent],
})
export class CompaniaModule { }
